import { render } from "./LifeCoachingPage.vue?vue&type=template&id=54fcfaac&scoped=true"
import script from "./LifeCoachingPage.vue?vue&type=script&lang=js"
export * from "./LifeCoachingPage.vue?vue&type=script&lang=js"

import "./LifeCoachingPage.vue?vue&type=style&index=0&id=54fcfaac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fcfaac"]])

export default __exports__